export default "__VITE_ASSET__D3FOITa7__"